import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Panache Apparel Co. (b_5m4wqw135i, advertiser -6701498702104650937).
// Lifetime complete-month metrics through Aug 2026 from CAMPAIGN_PERIODS.
export const advPanacheApparel: FaireAdvertiserProfileEntity = {
  token: "adv_panache_apparel",
  type: "advertiserProfile",
  archetype: "budget-capped",
  displayName: "Panache Apparel Co.",
  brandToken: "b_5m4wqw135i",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 25,
  budget: {
    totalBudgetDollars: 13000,
    sharedBudgetDollars: 13000,
    spendingMode: "COMPETITIVE",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 840,
    numReorderConversions: 654,
    numTotalConversions: 1494,
    totalAdsSalesDollars: 1388403,
    newCustomerAdsSalesDollars: 922693,
    reorderAdsSalesDollars: 465711,
    totalAdsSpendDollars: 85847,
    newCustomerAdsSpendDollars: 58940,
    reorderAdsSpendDollars: 26906,
    newCustomerBestEstimateFirstYearRoas: 18.4,
    reorderRoas: 17.31,
    combinedFirstYearRoas: 18.06,
    numNewCustomerAdsOrders: 2340,
    numReorderAdsOrders: 1248,
  },
  availableCredit: { totalRemainingDollars: 0 },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 15030,
      maxRecommendedBudgetDollars: 17030,
      isEligibleForIncreaseRec: true,
    },
    reorder: {
      minRecommendedBudgetDollars: 7540,
      maxRecommendedBudgetDollars: 9540,
      isEligibleForIncreaseRec: false,
    },
  },
  campaignTokens: ["camp_pa_new", "camp_pa_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-24T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
